import { Route } from 'react-router';
import { getOpcoUsersPath } from '../path/path';
import { OpcoUsersPage } from '../OpcoUsersPage';
import { OpcoUserDetailsPage } from '@/bundle/_Opco/_OpcoUsersPage/OpcoUserDetailsPage/OpcoUserDetailsPage';
import { getOpcoUserDetailsPath } from '@/bundle/_Opco/_OpcoUsersPage/OpcoUserDetailsPage/path/path';

export const OpcoUserRoutes = [
  <Route key={getOpcoUsersPath()} path={getOpcoUsersPath()} element={<OpcoUsersPage />} />,
  <Route key={getOpcoUserDetailsPath()} path={getOpcoUserDetailsPath()} element={<OpcoUserDetailsPage />} />,
];
